import React from "react";

import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";

import { CurrencyInput } from "../../../currency-input";
import { useEditableCell } from "../../../hooks/use-editable-cells";
import { type RebudgetingTableRow } from "../mid-cycle-rebudgeting-table";

export const ProposedBudgetDataFormatter = ({
  column,
  row: _row,
  onBlur,
}: DataTypeProvider.ValueFormatterProps & {
  onBlur: () => void;
}) => {
  const { user } = useUser();
  const row = _row as RebudgetingTableRow;

  const { editedValue, updateEditedValue } = useEditableCell<number>({
    rowId: row.id,
    columnName: column.name,
  });

  const target = row.data.proposedBudgetedSpend;
  const value = editedValue === undefined ? target : editedValue;

  return (
    <div
      className="font-medium text-sm flex justify-start items-center min-w-full h-full pr-[2px]"
      data-column={column.name}
      data-row={row.id}
    >
      <CurrencyInput
        inputClassName={
          row.metadata.hasAlert
            ? "border border-mars+1 outline-none focus:ring-1 focus:ring-mars"
            : ""
        }
        currencyCode={user.currencies.currentCurrency}
        onChange={(val) => updateEditedValue(val)}
        value={value}
        minValue={row.data.actualSpend}
        onBlur={onBlur}
      />
    </div>
  );
};
